module.exports = __webpack_public_path__ + "static/media/ikona-instagram.b472f305.svg";